<template>
    <div>
        <div class="text-center font-bold glot-text-font-size-16 glot-text-line-height-20 glot-text-color-EB" v-html="$t('PasswordChanged')"></div>
        <div class="flex flex-col justify-center items-center">
          <img class="mt-4" src="@/assets/images/icons/rocketIcon.png"/>
          <div class="text-center glot-text-font-size-14 glot-text-line-height-20 mt-6 glot-text-color-EB">
            {{$t('BackToLogin')}}
          </div>
    </div>
    </div>
</template>

<script>

const { BroadcastChannel } = require('broadcast-channel')

export default {
  components: {
  },
  data () {
    return {
      timeOutId: null
    }
  },
  computed: {
  },
  methods:{
  },
  mounted () {
    const vm = this
    this.timeOutId = setTimeout(() => {
      const channel = new BroadcastChannel('foobar')
      window.glotId = Date.now()
      channel.postMessage({focus: window.glotId}).then(() => {
        vm.$router.push(`/?continue=${localStorage.getItem('continueDomain')}`)
        channel.close()
      })
    }, 3000)
  },
  beforeDestroy () {
    clearTimeout(this.timeOutId)
  }
}
</script>

<style lang="scss">
.login-tabs-container {
  min-height: 505px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
</style>
